export default "__VITE_ASSET__COIBJfoT__"